// AgentVerse/common/schemas/collections/messageLog.js
import { z } from "zod";

const AttachmentSchema = z.object({
    fileId: z.string().describe("Unique ID of the uploaded file (from UploadDownloadService or similar)."),
    fileName: z.string().describe("Original name of the file."),
    mimeType: z.string().optional().describe("MIME type of the file."),
    size: z.number().optional().describe("Size of the file in bytes."),
    url: z.string().optional().describe("Publicly accessible URL if available (e.g., pre-signed for a short period).") // For Phase 1, this might be a /download/:key style URL
});

const MessageLogSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    conversationId: z.string().describe("ID linking messages in the same thread/group/DM. Can be a channelId or a compound ID for DMs."),
    subscriptionId: z.string().describe("The subscription this message belongs to."),

    projectId: z.string().describe("The project this message belongs to."), // For scoping

    senderContactId: z.string().describe("Contact ID of the sender (from MessagingContacts)."),
    // senderType: z.enum(["internal_user", "external_contact", "agent"]).describe("Type of the sender."), // Redundant if resolved from MessagingContacts

    recipientType: z.enum(["contact", "channel"]).describe("Type of the recipient."),
    recipientId: z.string().describe("Contact ID or Channel ID of the recipient."),

    messageType: z.enum(["text", "file", "image", "system", "agent_action_request", "agent_action_response"])
        .default("text").describe("Type of message content."),
    content: z.string().optional().nullable().describe("Text content of the message. For files, this might be a caption or empty."),
    // agentToolCall: z.any().optional().describe("If messageType is 'agent_action_request', structured data for a tool call."),
    // agentToolResponse: z.any().optional().describe("If messageType is 'agent_action_response', structured data for a tool response."),

    attachments: z.array(AttachmentSchema).optional().default([]).describe("Array of attachments."),

    timestamp: z.coerce.date().describe("When the message was sent/received by the server."),
    readBy: z.array(z.object({
        contactId: z.string(),
        readAt: z.coerce.date(),
    })).optional().default([]).describe("List of contacts who have read the message (primarily for group/channel chats)."),
    metadata: z.record(z.any()).optional().describe("Additional message-specific metadata."),
    isDeleted: z.boolean().default(false).describe("Soft delete flag."),
});

export default MessageLogSchema;
export { AttachmentSchema };